import React, { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What's a strategy?",
      answer: "A strategy is a way of selecting fighters in the UFC that can be systematically repeated. For instance, always picking the favorite could be considered a strategy, as could only picking fighters who won their last fight and are over 6 feet tall."
    },
    {
      question: "What's a playbook?",
      answer: "A playbook is a collection of strategies. When Odikai builds your playbook, we analyze how your selected strategies performed over the last year to determine how much money should be allocated to each strategy. Then, when building picks for an event, we gather the picks for every strategy in your playbook, combine them, and provide you with the picks that have the highest weight after combining all of your strategies."
    },
    {
      question: "Why can I only pick from these specific strategies?",
      answer: "Currently, Odikai only supports this 'basic' method of playbook building. Future versions will include a more 'advanced' playbook design tool."
    },
    {
      question: "What's a favorite? What's an underdog? What do the numbers on this page mean?",
      answer: [
        "When placing a bet, you'll encounter odds that indicate the potential payout if the bet wins and the likelihood of it being correct as assessed by the sportsbooks. American odds are presented as '-400' or '+185', while decimal odds are shown as '1.25' or '2.85'.",
        "For American odds, the favorite is indicated by a minus sign (-), and the underdog by a plus sign (+). The favorite is considered more likely to win by the sportsbooks. The underdog is seen as less likely to win. For example, odds of -1000 suggest a higher likelihood of winning compared to -500 or +350.",
        "For decimal odds, the favorite has the lower number, and the underdog has the higher number. Odds of 1.10 indicate a higher likelihood of winning compared to 1.20 or 4.5.",
        "If you choose 'At least 1.25 (-400)' as your Big Favorites Strategy, that means the strategy would select fighters where their odds are at least 1.25/-400. This would include fighters with odds of 1.2/-500 but exclude those with odds of 1.5/-200."
      ]
    },
    {
      question: "What's a parlay? What's a parlay leg?",
      answer: "A parlay is a combination of bets, each referred to as a leg. A 3-leg parlay consists of three different bets, with the overall odds of the parlay determined by the odds of each leg. A parlay only pays out if all bets within it are correct."
    },
    {
      question: "What's a capper?",
      answer: "A capper is someone who creates, shares, or sells betting picks. Technically, anyone who bets on the UFC could be considered a capper, but the term is typically used for individuals who sell or share their picks publicly. We model our UFC cappers based on their publically available picks and use AI to generate unique names that reflect their approach to choosing winners."
    },
    {
      question: "Why can my total wager be less than my budget?",
      answer: "The total wager is determined by the bets generated from the included strategies and is based on how we build and test our playbooks. To maximize returns, we recommend betting the suggested total wager rather than increasing your budget to match how much you may want to spend. If it's optimal for a playbook to bet your entire budget, this will be reflected in the total wager."
    }
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <div className="page-container">
        <header className="page-header">
          <div className="header-content">
            <h1>Frequently Asked Questions</h1>
            <p className="header-subtitle">Find answers to common questions about Odikai</p>
          </div>
        </header>

        <div className="faq-container">
          <div className="faq-content">
            <div className="faq-list">
              {faqs.map((faq, index) => (
                <div 
                  key={index} 
                  className={`faq-item ${openIndex === index ? 'open' : ''}`}
                  onClick={() => toggleFaq(index)}
                >
                  <div className="faq-question">
                    <h3>{faq.question}</h3>
                    <div className="faq-arrow"></div>
                  </div>
                  <div className="faq-answer">
                    {Array.isArray(faq.answer) ? (
                      faq.answer.map((paragraph, pIndex) => (
                        <p key={pIndex}>{paragraph}</p>
                      ))
                    ) : (
                      <p>{faq.answer}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
} 